import styled from 'styled-components';

export const EmptyState = styled.div`
  align-items: center;
  border: 1px dashed var(--color-border);
  border-radius: 12px;
  color: var(--color-text-muted);
  display: flex;
  font-size: 14px;
  justify-content: center;
  min-height: 140px;
  text-align: center;
`;
